import { PageDto, WidgetDto } from '@asset-metrix/portal-gateway-client-js';

function isStakeAdjustmentWidget(widget: WidgetDto): boolean {
  return (
    (widget.entity.type === 'table' || widget.entity.type === 'vegaChart') &&
    widget.entity.config.enableStakeAdjustment === true
  );
}

/**
 * Returns true if any content on the page (across all tabs) supports
 * stake adjustment. Used for URL-sync so the search param key stays
 * registered regardless of which tab is active.
 */
export function hasAnyStakeAdjustmentContent(
  contents: PageDto['contents']
): boolean {
  for (const content of contents) {
    if (content.type === 'widget' && isStakeAdjustmentWidget(content)) {
      return true;
    }
    if (
      (content.type === 'singleColumnGroup' ||
        content.type === 'twoColumnGroup') &&
      hasAnyStakeAdjustmentContent(content.contents)
    ) {
      return true;
    }
    if (
      content.type === 'tabGroup' &&
      content.contents.some((tab) => hasAnyStakeAdjustmentContent(tab.contents))
    ) {
      return true;
    }
  }
  return false;
}

/**
 * Returns true if any currently visible content supports stake adjustment.
 * For tab groups, only the active tab's contents are checked.
 * @param activeTabValues - map of tabGroupId -> active tab id
 */
export function hasVisibleStakeAdjustmentContent(
  contents: PageDto['contents'],
  activeTabValues: Record<string, string>
): boolean {
  for (const content of contents) {
    if (content.type === 'widget' && isStakeAdjustmentWidget(content)) {
      return true;
    }
    if (
      (content.type === 'singleColumnGroup' ||
        content.type === 'twoColumnGroup') &&
      hasVisibleStakeAdjustmentContent(content.contents, activeTabValues)
    ) {
      return true;
    }
    if (content.type === 'tabGroup') {
      const activeTabValue = activeTabValues[content.id];
      const activeTab = activeTabValue
        ? content.contents.find((tab) => tab.id === activeTabValue)
        : content.contents[0];
      if (
        activeTab &&
        hasVisibleStakeAdjustmentContent(activeTab.contents, activeTabValues)
      ) {
        return true;
      }
    }
  }
  return false;
}
